import { render, staticRenderFns } from "./TranscriptionList.vue?vue&type=template&id=847fad66&"
import script from "./TranscriptionList.vue?vue&type=script&lang=js&"
export * from "./TranscriptionList.vue?vue&type=script&lang=js&"
import style0 from "./TranscriptionList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports